var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{attrs:{"disabled":!_vm.hasEditPermission}},[_c('EmployerPricing',{attrs:{"employerId":_vm.employerId}}),_c('EmployerInvestmentSettings',{attrs:{"employerId":_vm.employerId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }